"use strict";

/*==================================================================
▐	1. IMPORTS and EXPORTS
===================================================================*/
import Plyr from 'plyr';
import {gh} from '../general/general-helpers';

/*==================================================================
▐	2. PLAYER METHODS
===================================================================*/
/**
 * Inits the whole podcast player functionality
 */
export default function initPodcastPlayer( forceMobileView = false, customEvents = null ) {
	/* Player
	-------------------------------------------------------------------*/
	function togglePlayingClass( elem, action = 'toggle' ) {
		// for mobile styles hiding/showing controls on play button click
		elem.classList[action]( '--playing' );

		// category player view (for desktop design), hiding/showing controls on play button click
		if ( elem.classList.contains( '--category' ) ) {
			jQuery( elem ).parents( '.podcast-list__post' )[action + 'Class']( '--player-inactive' );
		}
	}

	function onPlayerReady( player, playerElem ) {

		// we need 2 events here because sometimes the code works for either one of the events (but not for the other)
		['ready', 'loadedmetadata'].forEach( eventName => {
			player.on( eventName, ( event ) => {

				// set time for hour and minutes words
				const podcastTimeTxt = event.target.querySelector( '.podcast-player__play_txt' );
				podcastTimeTxt.innerHTML = `${Math.floor(player.duration / 3600)} ч ${Math.floor(player.duration % 3600 / 60)} мин`

				// make the player visible after init
				event.target.parentElement.classList.remove('opacity-0')
			} );
		} );

		player.on('ready', (event) => {
			player.on( 'playing', ( event ) => {
				// show pointer cursor only when time becomes clickable
				event.target.querySelector( '.plyr__time--current' ).classList.add( 'cursor-pointer' );
			} );

			// when playback is finished
			player.on('ended', (event) => {
				togglePlayingClass( event.target.parentElement );
			});

		});
	}

	function getPlayerControls( mobile = false) {
		let seekIconEnds = '',
		    timeHTML     = '<div class="podcast-player__time_wrap d-flex"><div class="plyr__time plyr__time--current lh-1 d-inline-block" aria-label="Current time">00:00</div></div>';

		if (mobile) {
			seekIconEnds = '-mobile'
		}

		return `
<div class="plyr__controls p-0 color-accent">
	<div class="podcast-player__play_wrap d-flex align-items-center justify-content-between flex-1 base-trans">
		<div class="podcast-player__play_txt text-uppercase">0 ч 0 мин</div>
		
	    <button type="button" class="plyr__control podcast-player__play_btn" aria-label="Play, {title}" data-plyr="play">
	        <svg class="icon--pressed" role="presentation" style="width: 30px; height: 30px;"><use xlink:href="#p-icon__pause"></use></svg>
	        <svg class="icon--not-pressed text-white fill-accent base-trans" role="presentation" style="width: 30px; height: 30px;"><use xlink:href="#p-icon__play"></use></svg>
	        <span class="label--pressed plyr__tooltip" role="tooltip">Пауза</span>
	        <span class="label--not-pressed plyr__tooltip" role="tooltip">Включить</span>
	    </button>
	</div>
	<div class="podcast-player__other_wrap align-items-center flex-grow-1 base-trans">
	    <button type="button" class="plyr__control podcast-player__seek-btn" data-plyr="rewind">
	        <svg role="presentation"><use xlink:href="#p-icon__rewind${seekIconEnds}"></use></svg>
	        <span class="plyr__tooltip" role="tooltip">назад на {seektime} секунд</span>
	    </button>
	    <button type="button" class="plyr__control podcast-player__seek-btn" data-plyr="fast-forward">
	        <svg role="presentation"><use xlink:href="#p-icon__forward${seekIconEnds}"></use></svg>
	        <span class="plyr__tooltip" role="tooltip">вперед на {seektime} секунд</span>
	    </button>
	    <div class="podcast-player__progress_wrap flex-grow-1">
	        <div class="plyr__progress">
		        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
		        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
		        <span role="tooltip" class="plyr__tooltip">00:00</span>
		    </div>
            ${ mobile ? timeHTML : ''}
		</div>
	    ${ mobile ? '' : timeHTML}
	</div>
</div>
`;
	}

	let players,
	    options = {
		    seekTime:        15,
		    invertTime:      false,
		    displayDuration: false,
		    // controls:        getPlayerControls(),
	    };

	// find podcast-player elements
	(customEvents
		? customEvents
		: [ 'DOMContentLoaded', 'yadroAjaxPostsLoaded' ]).forEach( eventName => {

		document.addEventListener( eventName, ( event ) => {
			players = document.querySelectorAll( '.podcast-player' );
		} );
	} );


	// inits or destroys the player when screen width changes
	// or when podcast posts were loaded via AJAX
	( customEvents
		? [...customEvents, ...['designChangeTablet']]
		: [ 'DOMContentLoaded', 'designChangeTablet', 'yadroAjaxPostsLoaded']).forEach( eventName => {

		document.addEventListener( eventName, ( event ) => {
			// init player and its functionality (all podcast pages)
			players.forEach( ( elem ) => {
				const mobileLook = (forceMobileView
					|| !gh.isTabletDesign
					|| elem.classList.contains( '--force-m-view' ));

				if ( mobileLook ) {
					elem.classList.add( '--mobile-view' );
				} else {
					elem.classList.remove( '--mobile-view' );
				}

				// destroy
				elem?.yePlayerInstance?.destroy();

				// init
				options.controls = getPlayerControls( mobileLook );

				elem.yePlayerInstance = new Plyr( elem.querySelector( '.podcast-player__audio' ), options );
				onPlayerReady( elem.yePlayerInstance, elem );
			} );

		} )
	} ); // FOREACH | EVENT

	// on Play btn click
	jQuery( document ).on( 'click', '.podcast-player__play_btn', function(elem) {
		togglePlayingClass(jQuery(elem.target).parents('.podcast-player')[0] );
	} );

} // FNC
